module.exports = __webpack_public_path__ + "media/images/dummy-content/futwiz-square-14e05ba9d5922da326281479957fbf2b.png";